export const tr = {
    cancel: 'İptal'
};
